<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <div class="l-page__header c-page__header">
      <h2 class="c-page__header-title">
        编辑评估项目
      </h2>
      <div class="c-page__header-btns">
        <k-button
          v-if="activeName === 'xmInfo'"
          btn-text="保存项目信息"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          :loading="btnLoading"
          @click="handleSave"
        />
        <k-button
          btn-text="查看详情"
          :auth-type="false"
          type="primary"
          plain
          @click="openNavTab({ name: 'jxxfPgxmDetail', params: { id: xmId } })"
        />
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
    </div>

    <div class="l-page__body l-page--detail__body">
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="xmInfo"
        >
          <update-xminfo
            ref="xmInfo"
            @updateXminfo="handleXminfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="实施规划"
          name="action"
        >
          <action-info
            ref="actionInfo"
            type="edit"
            :xm-info="xmInfo"
            @saved="handleSettingSaved"
          />
        </el-tab-pane>
        <el-tab-pane
          label="评估明细"
          name="pgmx"
        >
          <pgmx-list
            ref="pgmxList"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import UpdateXminfo from './updateXminfo.vue';
import PgmxList from './pgmxList.vue';
import ActionInfo from './planInfo.vue';

export default {
  name: 'JxxfPgxmEdit',
  components: {
    UpdateXminfo,
    PgmxList,
    ActionInfo
  },
  data () {
    return {
      loading: false,
      btnLoading: false,
      activeName: 'xmInfo',
      xmInfo: {}
    };
  },
  computed: {
    xmId () {
      return this.$route.params.id;
    }
  },
  methods: {
    handleXminfo (data) {
      this.xmInfo = data;
    },
    handleSave () {
      this.btnLoading = true;
      Promise.resolve(this.$refs.xmInfo.handleSave()).finally(() => {
        this.btnLoading = false;
      });
    },
    handleSettingSaved () {
      this.$refs.xmInfo.init();
    }
  }
};
</script>
